import { PageModel, SurveyModel } from "survey-core";
import { ActionBar, ActionCard, Page, PageAdmin, Sidebar } from "../components";
import { TopBar } from "../components/TopBar";
import { SurveyElementBase } from "survey-react-ui";
import { Card } from "@rumbledirect/ui";
import { createStyles } from "antd-style";
import { theme } from "antd";

const useStyles = createStyles(({ css }) => ({
  standardAdminWrapper: css`
    display: flex;
    gap: 20px;
    flex-direction: row;

    @media (max-width: 1024px) {
      flex-direction: column;
    }

    .action-card {
      width: 400px;

      .ant-card {
        position: fixed;
        width: inherit;
      }

      @media (max-width: 1440px) {
        width: 280px;
      }

      @media (max-width: 1220px) {
        width: 220px;
      }

      @media (max-width: 1024px) {
        display: none;
      }
    }

    .action-bar {
      display: none;

      @media (max-width: 1024px) {
        display: block;
      }
    }

    .sd-title.sd-element__title.sd-panel__title {
      font-size: 17px;
      font-weight: 700;
      margin-bottom: 1.5rem;
    }

    .sv-scroll__scrollbar {
      display: none;
    }
  `,
  standardAdminCard: css`
    flex: 1 1 400px;

    @media (max-width: 1440px) {
      flex: 1 1 280px;
    }

    @media (max-width: 1220px) {
      flex: 1 1 220px;
    }
  `,
  surveyFooter: css`
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #e8e8e8;
    text-align: center;
    color: #999;
    font-size: 12px;
    line-height: 1.6;

    a {
      color: #999;
      text-decoration: underline;
    }

    p {
      margin: 0;
    }
  `,
}));

export const LayoutPanel = (props: PageModel) => {
  const layoutVariant = props.survey.layoutVariant;
  const survey = props.survey as SurveyModel;
  const { useToken } = theme;
  const { token } = useToken();

  const { styles } = useStyles();

  if (layoutVariant === "standard") {
    return (
      <main>
        <Page {...props} />
        <ActionBar model={props.survey.navigationBar} survey={survey} />
      </main>
    );
  }

  if (layoutVariant === "standardAdmin") {
    const { page } = props;
    return (
      <div className={styles.standardAdminWrapper}>
        <Card title={page.title} className={styles.standardAdminCard}>
          <PageAdmin {...props} />
        </Card>

        <div className="action-card">
          <ActionCard model={props.survey.navigationBar} />
        </div>

        <div className="action-bar">
          <ActionBar model={props.survey.navigationBar} survey={survey} />
        </div>
      </div>
    );
  }

  if (layoutVariant === "withTopBar") {
    return (
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <TopBar survey={survey} />
        <main style={{ padding: "24px 24px 0" }}>
          <div style={{ marginBottom: "48px" }}>
            <Page {...props} />
          </div>
          <div>
            <ActionBar model={props.survey.navigationBar} survey={survey} />
          </div>
          {!survey.locFooterText.isEmpty && (
            <footer className={styles.surveyFooter}>
              {SurveyElementBase.renderLocString(survey.locFooterText)}
            </footer>
          )}
        </main>
      </div>
    );
  }

  if (layoutVariant === "withSidebar") {
    return (
      <div style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>
        <main
          style={{
            flex: 1,
            border: `1px solid ${token?.colorBorderSecondary ?? "#d8d8d8"}`,
            padding: "0px 24px 24px",
            borderRadius: `${token.borderRadiusLG}px`,
            backgroundColor: "#fff",
            maxWidth: "100%",
          }}
        >
          <div style={{ marginBottom: "64px" }}>
            <Page {...props} />
          </div>
          <div>
            <ActionBar model={props.survey.navigationBar} survey={survey} />
          </div>
          {!survey.locFooterText.isEmpty && (
            <footer className={styles.surveyFooter}>
              {SurveyElementBase.renderLocString(survey.locFooterText)}
            </footer>
          )}
        </main>
        <Sidebar {...props} />
      </div>
    );
  }

  if (layoutVariant === "asPanel") {
    return (
      <div style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>
        <main
          style={{
            flex: 1,
            border: `1px solid ${token?.colorBorderSecondary ?? "#d8d8d8"}`,
            padding: "0px 24px 24px",
            borderRadius: `${token.borderRadiusLG}px`,
            backgroundColor: "#fff",
            maxWidth: "100%",
          }}
        >
          <div style={{ marginBottom: "64px" }}>
            <Page {...props} />
          </div>
          <div>
            <ActionBar model={props.survey.navigationBar} survey={survey} />
          </div>
          {!survey.locFooterText.isEmpty && (
            <footer className={styles.surveyFooter}>
              {SurveyElementBase.renderLocString(survey.locFooterText)}
            </footer>
          )}
        </main>
      </div>
    );
  }
};
